import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./securityReviewProgressIndicator.html";
class SecurityReviewProgressIndicator extends LightningElement {
  constructor(...args) {
    super(...args);
    this.steps = void 0;
  }
  get processedSteps() {
    return this.steps.map((element, index) => {
      return {
        title: element.title,
        description: element.description,
        estimatedText: element.estimatedText,
        status: element.status,
        imageClass: 'card-body slds-align_absolute-center ' + element.status,
        subIconClass: 'small-icon ' + element.status,
        cardClass: 'slds-card ' + element.status,
        titleClass: 'title slds-m-top_x-large ' + element.status + (index === 3 ? ' completed ' : ''),
        mainIcon: element.mainIcon,
        subIcon: element.subIcon
      };
    });
  }
  /*LWC compiler v7.1.3*/
}
SecurityReviewProgressIndicator.delegatesFocus = true;
_registerDecorators(SecurityReviewProgressIndicator, {
  publicProps: {
    steps: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(SecurityReviewProgressIndicator, {
  tmpl: _tmpl,
  sel: "appx-security-review-progress-indicator",
  apiVersion: 62
});
export default __lwc_component_class_internal;